import { notify } from "../../../../../utils/notify";
import { search } from "../../../../BaseRepositoryComponents";

const searchParams = new URLSearchParams(window.location.search);
const path = `${process.env.REACT_APP_URL_API_ERP_V3}/multitenant/bff/taxnote`;

const headers = new Headers();
const token = `Bearer ${searchParams.get("gfAccessToken") || ""}`;
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function getDuplicate({ nfeId = null }) {
  if (!token)
    return notify(
      "Não foi possível conectar aos nossos servidores, tente novamente mais tarde."
    );

  const url = new URL(`${path}/${nfeId}/duplicate`);

  return search(decodeURIComponent(url), "GET", headers);
}

export async function duplicatePrint({ nfeId = null, duplicateIds = [] }) {
  if (!token)
    return notify(
      "Não foi possível conectar aos nossos servidores, tente novamente mais tarde."
    );

  const url = new URL(`${path}/${nfeId}/duplicate/print`);

  if (Array.isArray(duplicateIds)) {
    duplicateIds.map((id) => url.searchParams.append(`duplicate_ids[]`, id));
  }

  return search(decodeURIComponent(url), "GET", headers);
}

export async function getTaxNoteSupplier({
  nfInitialEmissionDate = "",
  nfFinalEmissionDate = "",
  supplierId = "",
  supplierName = "",
  supplierEmail = "",
  supplierCellPhone = "",
  supplierDocument = "",
  page = 1,
  perPage = 10,
}) {
  if (!token)
    return notify(
      "Não foi possível conectar aos nossos servidores, tente novamente mais tarde."
    );

  const url = new URL(`${path}/third-party/supplier`);

  url.searchParams.append("nfInitialEmissionDate", nfInitialEmissionDate);
  url.searchParams.append("nfFinalEmissionDate", nfFinalEmissionDate);
  url.searchParams.append("supplierId", supplierId);
  url.searchParams.append("supplierName", supplierName);
  url.searchParams.append("supplierEmail", supplierEmail);
  url.searchParams.append("supplierCellPhone", supplierCellPhone);
  url.searchParams.append("supplierDocument", supplierDocument);
  url.searchParams.append("page", page);
  url.searchParams.append("perPage", perPage);

  return search(decodeURIComponent(url), "GET", headers);
}
